import React from 'react';
import { useSelector } from 'react-redux';
import {
  Preview1,
  Preview2,
  Preview3,
  Preview4,
  Preview5,
  Preview6,
  Preview7,
  ThemeWrapper,
} from '@inplayer-org/inplayer-ui';
import styled, { ThemeProvider } from 'styled-components';
import includes from 'lodash/includes';
import reduce from 'lodash/reduce';

// data
import { light, dark } from 'data/themes';

// types
import { Branding } from 'pages/MerchantPages/Settings/Branding/components/Preview';
import RootState from 'ducks/RootState';
import { AccessControlType } from 'ducks/merchantDucks/accesses/actions';

/* set box shadow on wrapper for template 1 and on 
  nested div (#preview-container) for others templates */
const PreviewTemplateWrapper = styled.div<{ templateId?: number }>`
  ${({ templateId }) => templateId === 1 && `box-shadow: 0 1px 8px 0 #b9c1cb`};
  #preview-container {
    box-shadow: 0 1px 8px 0 #b9c1cb;
  }
`;

const templates = {
  0: Preview1,
  1: Preview1,
  2: Preview2,
  3: Preview3,
  4: Preview4,
  5: Preview5,
  6: Preview6,
  7: Preview7,
};

interface Props {
  previewTemplateId?: number;
  branding?: Branding;
  assetCountrySetId?: number;
  assetDomainRestrictions?: Array<any>;
  displayBuyButton?: boolean;
  previewUnavailable?: boolean;
  defaultAssePreviewDetails?: boolean;
  height?: string;
  width?: string;
  accessControlTypeId?: number;
  isTemplate?: boolean;
}

const AssetPreview = ({
  previewTemplateId = 1,
  width,
  branding,
  accessControlTypeId,
  isTemplate = false,
  ...otherProps
}: Props) => {
  // It should be checked if there is a preview for given template id
  // There are some assets and brandings with template id bigger than
  // the number of available previews and aplication crashes
  const validTemplateId = includes(Object.keys(templates), previewTemplateId.toString()) ? previewTemplateId : 1;
  const itemDetails = useSelector((state: RootState) => state.items.itemDetails);
  const templateDetails = useSelector((state: RootState) => state.items.templates.templateDetails);
  const loginFooterLabel =
    accessControlTypeId === AccessControlType.CODEONLY ? '' : 'Already have access? Login with your account.';

  const PreviewTemplate = templates[validTemplateId];

  // this is a backend flaw, metadata is sent as object
  // which containes array of objects
  const templateMetadata = reduce(
    templateDetails.metadata,
    (obj: any, { name, value }: any) => ({ ...obj, [name]: value }),
    {}
  );

  const { paywall_cover_photo: metaCoverPhoto } = isTemplate ? templateMetadata : itemDetails.metadata;
  let coverPhoto = 'https://inplayer-paywall-v2.s3.amazonaws.com/images/ip-preview-premium.jpg';

  if (metaCoverPhoto && metaCoverPhoto !== coverPhoto) {
    coverPhoto = metaCoverPhoto;
  } else if (branding?.paywall_cover_photo) {
    coverPhoto = branding.paywall_cover_photo;
  }

  let isDarkModeEnabled = false;
  if (branding) {
    const { dark_mode: isBrandingDarkModeEnabled } = branding;
    isDarkModeEnabled = !!isBrandingDarkModeEnabled;
  }

  const theme = {
    ...(isDarkModeEnabled ? dark : light),
  };

  return (
    <ThemeWrapper theme={theme} withProvider={ThemeProvider}>
      <PreviewTemplateWrapper templateId={validTemplateId}>
        <PreviewTemplate
          width={width ?? '100%'}
          loginFooterLabel={loginFooterLabel}
          branding={{ ...branding, paywall_cover_photo: coverPhoto }}
          {...otherProps}
        />
      </PreviewTemplateWrapper>
    </ThemeWrapper>
  );
};

export default AssetPreview;
